import React from 'react';
import styles from './TableTopHeader.module.css';
import SearchInput from '../../Atoms/Inputs/SearchInput';
import MoreButton from '../Custom/PopOver/MoreButton';
import moreicon from '../../../assets/Imagess/moreicon.svg';
import exportICon from '../../../assets/Imagess/exportIcon.svg';
import printicon from '../../../assets/Imagess/printIcon.svg';
import PopOver from '../Custom/PopOver/PopOver';
import axiosInstance from '../../../Hooks/services/axiosInstance';
import { exportToExcel, handleExport } from '../../../utils/ExportFuntion';
import { toast } from 'react-toastify';
const defaultExportData = {
  api: '',
  payload: {
    pageSize: 0,
    pageNumber: 1,
    searchBy: '',
    desc: true,
    sortBy: '',
    selected: false,
    filterColumns: [],
  },
  visibleColumn: {},
  tableHeader: [],
  fileName: 'Export',
  combinedData: [],
  isData: false,
};
const TableTopHeader = ({
  rightButtons,
  search,
  setSearch,
  isSearch,
  leftComponent,
  additionalButtons,
  handlePrint = null,
  exportData = defaultExportData,
}) => {
  const prepareColumnsForExport = (visibleColumns, tableHeader) => {
    return tableHeader
      .filter((col) => visibleColumns[col.key])
      .map((col) => ({
        key: col.key,
        header: col.title,
        width: 20,
      }));
  };

  return (
    <>
      <div className={styles['icon-container']}>
        <div className={styles['icon-subcontainer']}>
          {isSearch && <SearchInput search={search} setSearch={setSearch} />}
          {leftComponent && leftComponent}
        </div>

        <div className={styles['icon-subcontainer']}>
          <div className={styles['multi_icon_cont']}>
            {additionalButtons && additionalButtons}
          </div>
          <div className={styles['iconFilter-subcontainer']}>
            {rightButtons}

            <MoreButton icon={moreicon} toolTipText='More'>
              <PopOver
                stop
                info={[
                  {
                    title: 'Export',
                    icon: exportICon,
                    handleFunction: () => handleExport(exportData),
                  },
                  {
                    title: 'Print',
                    icon: printicon,
                    handleFunction: handlePrint,
                  },
                ]}
              />
            </MoreButton>
          </div>
        </div>
      </div>
      {additionalButtons && (
        <div className={styles['mobile']}>{additionalButtons}</div>
      )}
    </>
  );
};

export default TableTopHeader;
